import { withStyles } from '@material-ui/core/styles';
import styles from './Pill.styles';
import Pill from './Pill';

export default withStyles(styles)(Pill);
